<div class="col-sm-12">
  <div class="text-center error-box">
    <h2 class="font-xl">
        <strong>
            <i class="fa fa-fw fa-warning fa-lg text-warning"></i> Records <u>not</u> found
        </strong>
    </h2>
    <br>
    <p class="lead">
        We are sorry but in our database we do not have any records that match your search.
    </p>
    <p *ngIf="tryAgain" class="font-md"><b>......Try another query in the search engine</b></p><br>
</div>
</div>